import { Text as AntdText } from "@empglabs/backoffice-ui-kit"

const Text = props => {
  return <AntdText {...props} />
}

export default Text
